module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAA5klEQVQoU2MUL/uwi4GBYeXLLoG5ouWf7Zj+/2ln/svs/6yX7w0DFDCKl33yY2D4t5KBgSmH9ffHZb9ZeTcyMPyXYP7L7ARTyAhSLF7y3p+BiXEFLoVgRYQUwhXBFTIyrvzHxOTC/uvj2d8svJsYGP6zoCgSK/2Qycjwr+8fA6PlDxbmx1x//u1hZGS4B1cEU8DIwBD8lYXlJEgBA8P/d8wfv/uCFeFT8GyW1DdGsZIP6YyM/yaATPjOzHSc4y/DPpgJIAUgQxglSt4vYmBmWv6ik3+7WMknS0amf3nMH74lwxSAFAEAgIV5c1CZlp0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r1.png
// module id = 1qNH
// module chunks = 15